<app-file-header [file]="file" [parentType]="parentType" [parentId]="parentId"></app-file-header>
<app-viewer-content *ngIf="file" [file]="file"></app-viewer-content>
